(() => {
  const catalog = window.BARN_STABLE_LX_CATALOG;
  const root = document.querySelector('#catalog-root');
  if (!catalog || !root) return;

  const colorHex = color => {
    const value = color.toLowerCase();
    if (value.includes('burgundy') || value.includes('crimson') || value.includes('red')) return '#9b1f2e';
    if (value.includes('purple')) return '#5d377f';
    if (value.includes('royal blue')) return '#1f5eb8';
    if (value.includes('blue')) return '#3179ad';
    if (value.includes('navy')) return '#17263d';
    if (value.includes('evergreen')) return '#355b47';
    if (value.includes('golden') || value.includes('mustard') || value.includes('gold')) return '#c89935';
    if (value.includes('silver') || value.includes('grey')) return '#b9bdba';
    if (value.includes('sand')) return '#c9b693';
    if (value.includes('brown') || value.includes('chestnut')) return '#694535';
    if (value.includes('orange')) return '#d66b2d';
    if (value.includes('white')) return '#f0eee7';
    return '#202020';
  };

  const card = (group, item, number) => {
    const productName = item.productName || group.title;
    const productUrl = `/pages/product-details?asin=${encodeURIComponent(item.asin)}`;
    const sectionName = catalog.sections.find(section => section.id === group.section)?.title || group.section.replaceAll('-', ' ');
    const sizes = item.sizes.length ? item.sizes.map(size => `<span>${size}</span>`).join('') : '<span>See Amazon</span>';
    const media = item.image && item.imageVerified !== false
      ? `<img src="${item.image}" alt="${productName} — ${item.color}" loading="lazy" decoding="async">`
      : `<span class="catalog-image-pending"><img src="${window.BARN_STABLE_LOGO || ''}" alt="" loading="lazy" decoding="async"><b>${item.color}</b><small>Exact image source required</small></span>`;
    const unavailable = !item.price && /unavailable/i.test(item.status || '');
    const pending = !item.price && /pending/i.test(item.status || '');
    const priceLabel = item.price || (pending ? 'Coming soon' : unavailable ? 'Unavailable' : 'Check price');
    const priceMeta = item.listPrice ? `List <s>${item.listPrice}</s>` : (item.status || 'Current Amazon price');
    return `
      <article class="catalog-product js-search-card reveal" data-search="${sectionName} ${group.title} ${productName} ${group.detail} ${item.color} ${item.sizes.join(' ')} ${item.asin} ${item.sku || ''}">
        <a class="catalog-product-media" href="${productUrl}" aria-label="View details for ${productName}, ${item.color}">
          <span class="catalog-product-no">${group.index}.${String(number + 1).padStart(2, '0')}</span>
          ${item.discount ? `<span class="catalog-discount">${item.discount}</span>` : ''}
          ${media}
        </a>
        <div class="catalog-product-copy">
          <div class="catalog-color"><i style="--color:${colorHex(item.color)}"></i><span>${item.color}</span></div>
          <h3><a href="${productUrl}">${productName}</a></h3>
          <p>${group.detail}</p>
          <div class="catalog-sizes"><small>Available sizes</small><div>${sizes}</div></div>
          <div class="catalog-price">
            <strong>${priceLabel}</strong>
            <span>${priceMeta}</span>
          </div>
          <a class="catalog-buy" href="${item.amazon}" data-attribution-family="${group.family}" target="_blank" rel="noopener noreferrer"><span>View on Amazon</span><b>↗</b></a>
        </div>
      </article>`;
  };

  const subgroup = group => `
    <div class="catalog-subgroup" id="${group.family}" data-family="${group.family}">
      <header class="catalog-subheading">
        <div><span>${group.index}</span><h3>${group.title}</h3></div>
        <p>${group.detail} · ${group.items.length} colorways</p>
      </header>
      <div class="catalog-product-grid">${group.items.map((item, index) => card(group, item, index)).join('')}</div>
    </div>`;

  const selectedSection = root.dataset.section || '';
  const horseSheetOrder = ['sheet420', 'mesh', 'sheet600', 'winter600', 'winter1680'];
  const orderHorseSheetGroups = groups => [...groups].sort((first, second) => {
    const firstIndex = horseSheetOrder.indexOf(first.family);
    const secondIndex = horseSheetOrder.indexOf(second.family);
    return (firstIndex === -1 ? 999 : firstIndex) - (secondIndex === -1 ? 999 : secondIndex);
  });
  const sections = catalog.sections.filter(section => !selectedSection || section.id === selectedSection).map(section => ({
    ...section,
    groups: section.id === 'horse-sheets'
      ? orderHorseSheetGroups(catalog.groups.filter(group => group.section === section.id))
      : catalog.groups.filter(group => group.section === section.id)
  }));

  root.innerHTML = sections.map(section => `
    <section class="catalog-section tone-${section.tone}" id="${section.id}">
      <header class="catalog-section-heading">
        <span>${section.index}</span>
        <div><p>${section.eyebrow}</p><h2>${section.title}</h2></div>
        <p>${section.intro}</p>
      </header>
      ${section.groups.map(subgroup).join('')}
    </section>`).join('');

  const cards = [...document.querySelectorAll('.js-search-card')];
  const colorwayCount = document.querySelector('#colorway-count');
  if (colorwayCount) colorwayCount.textContent = String(cards.length);
  const listingCount = document.querySelector('#listing-count');
  if (listingCount) listingCount.textContent = String(catalog.listingCount);
  const catalogTotalCount = document.querySelector('#catalog-total-count');
  if (catalogTotalCount) catalogTotalCount.textContent = String(catalog.groups.reduce((total, group) => total + group.items.length, 0));

  const searchForm = document.querySelector('.product-search');
  const searchInput = document.querySelector('#site-search');
  const searchStatus = document.querySelector('.search-status');
  const emptyState = document.querySelector('#catalog-empty');
  const localSearch = root.dataset.localSearch === 'true';
  const applySearch = () => {
    const query = (searchInput?.value || root.dataset.query || '').trim().toLowerCase();
    let visible = 0;
    cards.forEach(element => {
      const match = !query || element.dataset.search.toLowerCase().includes(query);
      element.hidden = !match;
      if (match) visible += 1;
    });
    document.querySelectorAll('.catalog-subgroup').forEach(group => {
      group.hidden = ![...group.querySelectorAll('.js-search-card')].some(element => !element.hidden);
    });
    document.querySelectorAll('.catalog-section').forEach(section => {
      section.hidden = ![...section.querySelectorAll('.js-search-card')].some(element => !element.hidden);
    });
    if (searchStatus) searchStatus.textContent = query ? `${visible} colorway${visible === 1 ? '' : 's'} found` : '';
    if (colorwayCount) colorwayCount.textContent = String(visible);
    if (emptyState) emptyState.hidden = visible !== 0;
    return visible;
  };
  if (localSearch) {
    searchInput?.addEventListener('input', applySearch);
    searchForm?.addEventListener('submit', event => {
      event.preventDefault();
      applySearch();
      const firstVisible = cards.find(element => !element.hidden);
      firstVisible?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }
  applySearch();

  const toast = document.querySelector('.prototype-toast');
  document.querySelectorAll('[data-prototype-message]').forEach(button => button.addEventListener('click', () => {
    toast.textContent = button.dataset.prototypeMessage;
    toast.classList.add('is-visible');
    clearTimeout(window.catalogToastTimer);
    window.catalogToastTimer = setTimeout(() => toast.classList.remove('is-visible'), 3200);
  }));

  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { threshold: .04 }) : null;
  document.querySelectorAll('.reveal').forEach(element => observer ? observer.observe(element) : element.classList.add('is-visible'));
})();
